import React from "react";

export const LazyFinancialTransaction = React.lazy(() =>
  import("../scenes/Financial/FinancialTransaction/FinancialTransaction")
);
export const LazyMafsaInsuranceReport = React.lazy(() =>
  import("../scenes/Financial/MafsaInsuranceReport/MafsaInsuranceReport")
);

export const LazyFinancialTransactionCategory = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/FinancialTransactionCategory/FinancialTransactionCategory"
  )
);
export const LazyCalenderEvent = React.lazy(() =>
  import(
    "../scenes/OrganizationDefinitions/CalenderEvent/CalenderEvent.js"
  )
);
export const LazyListOfLoan = React.lazy(() =>
  import("../scenes/Financial/ListOfLoan/ListOfLoan.jsx")
);

export const LazyPettyCashList = React.lazy(() =>
  import("../scenes/Financial/PettyCashList/PettyCashList.jsx")
);
